import { render, staticRenderFns } from "./ChoicePaymentRefuse.vue?vue&type=template&id=20f39939&scoped=true&"
import script from "./ChoicePaymentRefuse.vue?vue&type=script&lang=js&"
export * from "./ChoicePaymentRefuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f39939",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f39939')) {
      api.createRecord('20f39939', component.options)
    } else {
      api.reload('20f39939', component.options)
    }
    module.hot.accept("./ChoicePaymentRefuse.vue?vue&type=template&id=20f39939&scoped=true&", function () {
      api.rerender('20f39939', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/services/payments/ChoicePaymentRefuse.vue"
export default component.exports